import NuclearNoteView from "./NuclearNoteView";

export default NuclearNoteView;
